export default {
    verb: 'willUpdate',
    prerequisites: [],
    priority: Number.MAX_SAFE_INTEGER,
    description: 'Prevent CRUD operations in preview mode.',
    // this is the actual logic:
    logic: willUpdate
};

function willUpdate({ context }) {
    if (context.preview) {
        throw new Error('Updates are not allowed in preview mode.');
    }
}
